import AbstractResource from '@/api/abstractResource'
import {
  ActuCentroidAttributes,
  Centroid,
  CentroidAttributes,
  EntiteCentroidAttributes,
  InfoCentroidAttributes
} from '@/orrm/model/centroid'

export interface CentroidPayload<T extends CentroidAttributes = CentroidAttributes> {
  data: Centroid<T>[];
}

export default class CentroidsResource extends AbstractResource {
  getActualitesCentroids = async () => {
    return this.wrapResponse<CentroidPayload<ActuCentroidAttributes>>(await this.client.get('/actualites/centroids'))
  }

  getCommunesCentroids = async () => {
    return this.wrapResponse<CentroidPayload>(await this.client.get('/communes/centroids'))
  }

  getEntitesCentroids = async () => {
    return this.wrapResponse<CentroidPayload<EntiteCentroidAttributes>>(await this.client.get('/entites/centroids'))
  }

  getInfosCentroids = async () => {
    return this.wrapResponse<CentroidPayload<InfoCentroidAttributes>>(await this.client.get('/informations/centroids'))
  }
}
